import React from 'react';
import _ from 'lodash';
import { showErrorToast } from '../../../../../shared-components/BaseToast/Toast';

const SaveCloseActions = ({
  rowValues,
  setRowsBeingEdited,
  rowId,
  loading,
  campaignId,
  updateProducts,
  variants,
}) => {
  const closeEditRow = () => {
    setRowsBeingEdited((prevState) => {
      return {
        ...prevState,
        [rowId]: false,
      };
    });
  };
  const updateProductsCallback = (saveError) => {
    if (saveError) {
      showErrorToast(saveError);
    } else {
      closeEditRow();
    }
  };
  const getVariantsData = () => {
    const submitData = { ...rowValues };
    const variantsOrder = [];
    const variantsEqual = _.isEqual(
      submitData.variantDescriptorsOrder,
      variants
    );
    if (submitData.variantDescriptorsOrder && !variantsEqual) {
      submitData.variantDescriptorsOrder.map((d, index) => {
        const order = index + 1;
        if (d.legacyPostId === submitData.legacyPostId) {
          submitData.displayOrder = order;
        } else {
          variantsOrder.push({
            legacyPostId: d.legacyPostId,
            displayOrder: order,
          });
        }
      });
    }

    return [submitData, variantsOrder];
  };

  const saveRow = () => {
    const [submitData, variantsOrder] = getVariantsData();
    submitData.isDeleted = submitData.isDeleted === 'true';
    submitData.isSponsored = submitData.isSponsored === 'true';
    submitData.isTaxExempt = submitData.isTaxExempt === 'true';
    submitData.isShippingExempt = submitData.isShippingExempt === 'true';
    submitData.isSubscribable = submitData.isSubscribable === 'true';
    delete submitData.variantDescriptorsDisplay;
    delete submitData.shippingRestrictionsDisplay;
    delete submitData.variantDescriptorsOrder;
    updateProducts(
      campaignId,
      [submitData, ...variantsOrder],
      rowId,
      (saveError) => updateProductsCallback(saveError, rowId)
    );
  };

  return (
    <td className="actions-container">
      <button
        className="naked-button"
        type="button"
        onClick={() => saveRow()}
        disabled={loading}
      >
        <i className="far fa-save" />
      </button>
      <button
        className="naked-button"
        type="button"
        onClick={() => closeEditRow()}
        disabled={loading}
      >
        <i className="far fa-times" />
      </button>
    </td>
  );
};

export default SaveCloseActions;
